import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-funeral-secondary border-t border-funeral-border py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <h3 className="font-serif text-2xl text-funeral-gold mb-2">Kenangan.AI</h3>
            <p className="text-funeral-light text-sm">Layanan AI Memorial WhatsApp</p>
          </div>
          
          <div className="text-center md:text-right text-funeral-light text-sm">
            <p className="mb-1">&copy; 2024 PT AI Indonesia. All rights reserved.</p>
            <p>Office 88, Lantai 32, Kota Kasablanka, Jakarta 12870</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
